import { Nullable } from '@clearverify/types';

export const getTextInputPlaceholder = <TOption extends { id?: Nullable<string> }>(
  value: TOption[],
) => {
  if (!value[0]) return 'All options selected';
  if (value.length === 1) return '1 option selected';
  if (value.length === 0) return '';
  return `${value.length} options selected`;
};
